export const INVENTORY_GET_REQUEST = 'INVENTORY_GET_REQUEST';
export const INVENTORY_GET_SUCCESS = 'INVENTORY_GET_SUCCESS';
export const INVENTORY_GET_ERROR = 'INVENTORY_GET_ERROR';
export const INVENTORY_RESET_ON_PPID_CHANGE = 'INVENTORY_RESET_ON_PPID_CHANGE';
